import { AppDeployment, CompatibleProductTypeValues, HostingDisplayName, HostingQueryParamToHostingType, HostingTypesWithCloudComplianceBoundaries } from '@atlassian/mpac-types';
import { AtlassianProductHostingType } from '@atlassian/mpac-types/graphql-gateway-types';
export const formatVersionRange = _ref => {
  let {
    minimumVersion,
    maximumVersion
  } = _ref;
  if (!(minimumVersion && maximumVersion)) return '';
  if (minimumVersion === maximumVersion) {
    return minimumVersion;
  }
  return "".concat(minimumVersion, " - ").concat(maximumVersion);
};

// TODO: extract out commonality b/w this and `getCompatibleVersionsSummary` in `/VersionsTab/utils/compatibleVersionsSummary.js`
export const getProductCompatibilityList = compatibilities => compatibilities.map(compatibility => {
  const {
    name
  } = compatibility;
  if (compatibility.__typename === CompatibleProductTypeValues.CLOUD_PRODUCT) {
    return [name, HostingDisplayName[AtlassianProductHostingType.Cloud]].join(' ');
  }
  if (compatibility.__typename === CompatibleProductTypeValues.SERVER_PRODUCT) {
    const {
      minimumVersion,
      maximumVersion
    } = compatibility;
    return [name, HostingDisplayName[AtlassianProductHostingType.Server], formatVersionRange({
      minimumVersion,
      maximumVersion
    })].join(' ');
  }
  if (compatibility.__typename === CompatibleProductTypeValues.DATACENTER_PRODUCT) {
    const {
      minimumVersion,
      maximumVersion
    } = compatibility;
    return [name, HostingDisplayName[AtlassianProductHostingType.DataCenter], formatVersionRange({
      minimumVersion,
      maximumVersion
    })].join(' ');
  }
  return null;
}).filter(Boolean);
export const getProductCompatibilitySummary = compatibilities => getProductCompatibilityList(compatibilities).join(', ').trim();
export const compatibleWithCloudSupportedProduct = compatibleProducts => compatibleProducts.some(product => {
  var _product$atlassianPro;
  return (_product$atlassianPro = product.atlassianProduct) === null || _product$atlassianPro === void 0 ? void 0 : _product$atlassianPro.hostingOptions.some(option => option === AtlassianProductHostingType.Cloud);
});
export const pickVersionInfo = _ref2 => {
  let {
    compatibleProducts,
    licenseType,
    paymentModel,
    releaseDate,
    releaseNotes,
    releaseNotesUrl,
    releaseSummary,
    version,
    versionCount,
    versionHistoryUrl
  } = _ref2;
  return {
    compatibleProducts,
    licenseType,
    paymentModel,
    releaseDate,
    releaseNotes,
    releaseNotesUrl,
    releaseSummary,
    version,
    versionCount,
    versionHistoryUrl
  };
};
export const getTrustTabPrecondition = (selectedHosting, appListing) => {
  var _appListing$partner;
  return isSelectedHostingAllowedForPrivacyTab(selectedHosting) && (appListing.deploymentType === AppDeployment.ECOSYSTEM_CLOUD || appListing.deploymentType === AppDeployment.CONNECT || appListing.deploymentType === AppDeployment.INSTRUCTIONAL || appListing.deploymentType === AppDeployment.PLUGINS1 || appListing.deploymentType === AppDeployment.PLUGINS2) && ((_appListing$partner = appListing.partner) === null || _appListing$partner === void 0 ? void 0 : _appListing$partner.name) !== 'Atlassian';
};
export const isSelectedHostingAllowedForPrivacyTab = selectedHosting => {
  return selectedHosting === HostingQueryParamToHostingType.cloud || selectedHosting === HostingQueryParamToHostingType.isolatedcloud || selectedHosting === HostingQueryParamToHostingType.governmentcloud;
};
export const isHostingAGCOrIC = selectedHosting => {
  return selectedHosting === HostingTypesWithCloudComplianceBoundaries.IsolatedCloud || selectedHosting === HostingTypesWithCloudComplianceBoundaries.GovernmentCloud;
};